import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";

import { Container, Row } from "reactstrap";

import routes from "routes.js";

class Auth extends React.Component {
  
  getRoutes = routes => {
    return routes.map((prop, key) => {
      if (prop.layout === "/blank") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  render() {
    return (
      <>
          {/* <Container className="mt--8 pb-5">
            <Row className="justify-content-center"> */}
              <Switch>
                {this.getRoutes(routes)}
                <Redirect from="*" to="/blank/FechamentoPeriodo" />
              </Switch>
            {/* </Row>
          </Container> */}
      </>
    );
  }
}

export default Auth;
